import { Module, MutationTree, ActionTree, GetterTree } from "vuex";
export interface ClientInfo {
  name: string;
  registeredMail: {
    enabled: boolean;
  };
  expressMail: {
    enabled: boolean;
  };
  ems: {
    enabled: boolean;
  };
  dhl: {
    enabled: boolean;
  };
  parcel: {
    enabled: boolean;
  };
}
export interface CenterInfo {
  centerId: string;
  name: string;
  staff: boolean; // true: 유인, false: 무인
  registeredMail: {
    available: boolean;
  };
  expressMail: {
    available: boolean;
  };
  ems: {
    available: boolean;
  };
  dhl: {
    available: boolean;
  };
  parcel: {
    available: boolean;
  };
  quick: {
    available: boolean;
  };
}

export class authState {
  sessionToken: string = "";
  clientInfo: ClientInfo = {
    name: "",
    registeredMail: {
      enabled: false,
    },
    expressMail: {
      enabled: false,
    },
    ems: {
      enabled: false,
    },
    dhl: {
      enabled: false,
    },
    parcel: {
      enabled: false,
    },
  };
  centerInfo: CenterInfo = {
    centerId: "",
    name: "",
    staff: true, // true: 유인, false: 무인
    registeredMail: {
      available: false,
    },
    expressMail: {
      available: false,
    },
    ems: {
      available: false,
    },
    dhl: {
      available: false,
    },
    parcel: {
      available: false,
    },
    quick: {
      available: false,
    },
  };
  marketingAgreement: boolean | null = null;
}

const Mutations: MutationTree<authState> = {
  updateSessionToken(state: authState, payload: string) {
    state.sessionToken = payload;
  },
  updateClientInfo(state: authState, payload: ClientInfo) {
    state.clientInfo = payload;
  },
  updateCenterInfo(state: authState, payload: CenterInfo) {
    state.centerInfo = payload;
  },
  updateMarketingAgreement(state: authState, payload: boolean) {
    state.marketingAgreement = payload;
  },
};
const Actions: ActionTree<authState, any> = {
  updateSessionToken({ commit }, payload: string) {
    commit("updateSessionToken", payload);
  },
  updateClientInfo({ commit }, payload: vuex.auth.clientInfo) {
    commit("updateClientInfo", payload);
  },
  updateCenterInfo({ commit }, payload: CenterInfo) {
    commit("updateCenterInfo", payload);
  },
  updateMarketingAgreement({ commit }, payload: boolean) {
    commit("updateMarketingAgreement", payload);
  },
  reset({ dispatch }) {
    const state = new authState();
    dispatch("updateSessionToken", state.sessionToken);
    dispatch("updateClientInfo", {
      ...state.clientInfo,
    });
    dispatch("updateCenterInfo", state.centerInfo);
    dispatch("updateMarketingAgreement", state.marketingAgreement);
  },
};
const Getters: GetterTree<authState, any> = {
  getSessionToken: (state: authState) => (): string => {
    return state.sessionToken;
  },
  getClientInfo: (state: authState) => (): ClientInfo => {
    return state.clientInfo;
  },
  getCenterInfo: (state: authState) => (): CenterInfo => {
    return state.centerInfo;
  },
  getMarketing: (state: authState) => (): boolean | null => {
    return state.marketingAgreement;
  },
};

const module: Module<authState, any> = {
  namespaced: true,
  state: new authState(),
  mutations: Mutations,
  actions: Actions,
  getters: Getters,
};

export default module;
